import './theme.js';
import { composeSchema } from '@plone/volto/helpers';
import imagesSVG from '@plone/volto/icons/images.svg';

import { BG_CONTAINER_COLORS, BG_COLUMN_COLORS } from   './colors';
import addBackgroundColorStyling from './components/BlockSchemaEnhancer/Schema';

import ImageCarouselView from   './components/ImageCarousel/View';
import ImageCarouselEdit from   './components/ImageCarousel/Edit';
import ImageCarouselSchema from './components/ImageCarousel/Schema';

import BGContainerView from    './components/BGContainer/View';
import BGContainerEdit from    './components/BGContainer/Edit';
import BGContainerAdapter from './components/BGContainer/Adapter';
import BGContainerSchema from  './components/BGContainer/Schema';

import CountdownBlockView from './components/CountdownBlock/View';
import CountdownBlockEdit from './components/CountdownBlock/Edit';
import CountdownBlockSchema from './components/CountdownBlock/Schema';

import TerminListingTemplate from './components/Blocks/listing/TerminListingTemplate';

import PendingReviewBar from './components/PendingReviewBar/PendingReviewBar';

export default function applyConfig(config) {
  config.settings = {
    ...config.settings,
    reudnitzThemeLoaded: true,
    supportedLanguages: ['de'],
    defaultLanguage: 'de',
  };

  config.settings.appExtras = [
    ...(config.settings.appExtras ?? []),
    {
      match: '',
      component: PendingReviewBar,
    },
  ];

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'termineListing',
      title: 'Termine',
      template: TerminListingTemplate,
    },
  ];

  config.blocks = {
    ...config.blocks,
    themes: BG_CONTAINER_COLORS,
  };

  const blocksConfig     = config.blocks.blocksConfig;
  const defaultGridBlock = blocksConfig.gridBlock;

  config.blocks.blocksConfig.gridBlock = {
    ...defaultGridBlock,
    schemaEnhancer: composeSchema(
      defaultGridBlock?.schemaEnhancer,
      addBackgroundColorStyling,
    ),
  };

  config.blocks.blocksConfig.imageCarousel = {
    id: 'imageCarousel',
    title: 'Image Carousel',
    group: 'media',
    icon: imagesSVG,
    view: ImageCarouselView,
    edit: ImageCarouselEdit,
    sidebarTab: 1,
    mostUsed: true,
    restricted: false,
  };

  config.blocks.blocksConfig.bgContainer = {
    id: 'bgContainer',
    title: 'BG Container',
    group: 'common',
    icon: imagesSVG,
    view: BGContainerView,
    edit: BGContainerEdit,
    blockSchema: BGContainerSchema,
    dataAdapter: BGContainerAdapter,
    allowedBlocks: Object.keys(config.blocks.blocksConfig),
    blocksConfig: config.blocks.blocksConfig,
    schemaEnhancer: composeSchema(
      addBackgroundColorStyling,
    ),
    enableStyling: true,
    restricted: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.countdownBlock = {
    id: 'countdownBlock',
    title: 'Countdown',
    group: 'common',
    icon: imagesSVG,
    view: CountdownBlockView,
    edit: CountdownBlockEdit,
    blockSchema: CountdownBlockSchema,
    sidebarTab: 1,
    restricted: false,
    mostUsed: false,
  };

  const columnsBlockKey = Object.keys(config.blocks.blocksConfig).find(
    (key) => config.blocks.blocksConfig[key]?.id === 'columnsBlock',
  );

  if (columnsBlockKey) {
    config.blocks.blocksConfig[columnsBlockKey] = {
      ...config.blocks.blocksConfig[columnsBlockKey],
      available_colors: BG_COLUMN_COLORS,
    };
  }

  return config;
};
